import React from "react";
import SelectFilter from "../selectFilter";
import { EXPOSED_VALUES } from "../../../../../constants/values";
import { IFilterProps } from "../Interfaces";

const ExposedFilter: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
}) => (
  <SelectFilter
    setSelectedKeys={setSelectedKeys}
    confirm={confirm}
    clearFilters={clearFilters}
    options={EXPOSED_VALUES}
    selectedKeys={selectedKeys}
  />
);

export default ExposedFilter;
